import React, { useState, useEffect } from 'react';

export default function AdminPanel() {
  const [pendingApplications, setPendingApplications] = useState([]);
  const [applicationsLoading, setApplicationsLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchPendingApplications();
  }, []);

  const fetchPendingApplications = async () => {
    setApplicationsLoading(true);
    setError(null);
    try {
      console.log('Bekleyen başvurular yükleniyor...');
      const response = await fetch('/api/pending-applications');
      console.log('Bekleyen başvurular response:', response);
      if (!response.ok) {
        throw new Error(`HTTP ${response.status}: ${response.statusText}`);
      }
      const data = await response.json();
      console.log('Bekleyen başvurular data:', data);
      setPendingApplications(data);
    } catch (error) {
      console.error('Bekleyen başvurular yüklenemedi:', error);
      setError('Bekleyen başvurular yüklenirken hata oluştu. Lütfen tekrar deneyin.');
    } finally {
      setApplicationsLoading(false);
    }
  };

  const updateApplicationStatus = async (userId, newStatus) => {
    try {
      console.log(`Başvuru durumu güncelleniyor: User ID ${userId}, Status: ${newStatus}`);
      const response = await fetch(`/api/users/${userId}/status`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ basvuru_durumu: newStatus }),
      });
      
      if (!response.ok) {
        throw new Error(`HTTP ${response.status}: ${response.statusText}`);
      }
      
      console.log('Başvuru durumu güncellendi');
      // Show success message
      const statusText = newStatus === 'onayli' ? 'onaylandı' : 'reddedildi';
      alert(`Başvuru başarıyla ${statusText}!`);
      // Refresh the pending applications list
      fetchPendingApplications();
    } catch (error) {
      console.error('Başvuru durumu güncellenemedi:', error);
      alert('Başvuru durumu güncellenirken hata oluştu: ' + error.message);
    }
  };

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString('tr-TR', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  const getStatusBadge = (status) => {
    const statusMap = {
      'beklemede': { text: 'Beklemede', color: 'bg-yellow-100 text-yellow-800 border-yellow-200' },
      'onayli': { text: 'Onaylandı', color: 'bg-green-100 text-green-800 border-green-200' },
      'reddedildi': { text: 'Reddedildi', color: 'bg-red-100 text-red-800 border-red-200' }
    };
    
    const statusInfo = statusMap[status] || { text: status, color: 'bg-gray-100 text-gray-800 border-gray-200' };
    
    return (
      <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium border ${statusInfo.color}`}>
        {statusInfo.text}
      </span>
    );
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 py-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-white rounded-xl shadow-2xl overflow-hidden border border-gray-200">
          {/* Content */}
          <div className="p-8">
            <div className="flex items-center justify-between mb-6">
              <div>
                <h2 className="text-2xl font-bold text-gray-900">Bekleyen Başvurular</h2>
                <p className="text-gray-600 mt-2">Kullanıcı başvurularını inceleyin ve yönetin</p>
              </div>
              <button
                onClick={fetchPendingApplications}
                disabled={applicationsLoading}
                className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 disabled:opacity-50 disabled:cursor-not-allowed transition-all duration-200"
              >
                {applicationsLoading ? (
                  <>
                    <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2"></div>
                    Yükleniyor...
                  </>
                ) : (
                  <>
                    <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
                    </svg>
                    Yenile
                  </>
                )}
              </button>
            </div>

            {error && (
              <div className="mb-6 bg-red-50 border border-red-200 rounded-lg p-4">
                <div className="flex">
                  <div className="flex-shrink-0">
                    <svg className="h-5 w-5 text-red-400" viewBox="0 0 20 20" fill="currentColor">
                      <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
                    </svg>
                  </div>
                  <div className="ml-3">
                    <h3 className="text-sm font-medium text-red-800">Hata</h3>
                    <div className="mt-2 text-sm text-red-700">
                      <p>{error}</p>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {applicationsLoading ? (
              <div className="text-center py-16">
                <div className="animate-spin rounded-full h-16 w-16 border-b-2 border-blue-500 mx-auto"></div>
                <p className="mt-6 text-gray-600 text-lg">Bekleyen başvurular yükleniyor...</p>
                <p className="mt-2 text-gray-500 text-sm">Lütfen bekleyin</p>
              </div>
            ) : pendingApplications.length === 0 ? (
              <div className="bg-gradient-to-r from-yellow-50 to-orange-50 border border-yellow-200 rounded-xl p-8 text-center">
                <div className="mx-auto flex items-center justify-center h-16 w-16 rounded-full bg-yellow-100 mb-4">
                  <svg className="h-8 w-8 text-yellow-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                </div>
                <h3 className="text-lg font-medium text-yellow-800 mb-2">
                  Bekleyen Başvuru Yok
                </h3>
                <p className="text-yellow-700 max-w-md mx-auto">
                  Şu anda bekleyen başvuru bulunmuyor. Yeni başvurular geldiğinde burada görünecektir.
                </p>
              </div>
            ) : (
              <div className="bg-white rounded-xl shadow-lg overflow-hidden border border-gray-200">
                <div className="px-6 py-4 bg-gray-50 border-b border-gray-200">
                  <div className="flex items-center justify-between">
                    <h3 className="text-lg font-medium text-gray-900">
                      Toplam {pendingApplications.length} bekleyen başvuru
                    </h3>
                    <div className="text-sm text-gray-500">
                      Son güncelleme: {new Date().toLocaleTimeString('tr-TR')}
                    </div>
                  </div>
                </div>
                <div className="overflow-x-auto">
                  <table className="min-w-full divide-y divide-gray-200">
                    <thead className="bg-gray-50">
                      <tr>
                        <th scope="col" className="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                          Firma Bilgileri
                        </th>
                        <th scope="col" className="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                          İletişim
                        </th>
                        <th scope="col" className="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                          Başvuru Tarihi
                        </th>
                        <th scope="col" className="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                          Durum
                        </th>
                        <th scope="col" className="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                          İşlemler
                        </th>
                      </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-gray-200">
                      {pendingApplications.map((app, index) => (
                        <tr key={app.id} className={`hover:bg-gray-50 transition-colors duration-200 ${index % 2 === 0 ? 'bg-white' : 'bg-gray-50'}`}>
                          <td className="px-6 py-6">
                            <div className="text-sm">
                              <div className="font-semibold text-gray-900 text-base">{app.firma}</div>
                              <div className="text-gray-600 mt-1">Yetkili: {app.yetkili}</div>
                              <div className="text-gray-500 text-xs mt-1">{app.ulke}, {app.sehir}</div>
                            </div>
                          </td>
                          <td className="px-6 py-6">
                            <div className="text-sm">
                              <div className="text-gray-900 font-medium">{app.email}</div>
                              <div className="text-gray-600 mt-1">{app.telefon}</div>
                            </div>
                          </td>
                          <td className="px-6 py-6 whitespace-nowrap text-sm text-gray-600">
                            {formatDate(app.created_at)}
                          </td>
                          <td className="px-6 py-6 whitespace-nowrap text-sm">
                            {getStatusBadge(app.basvuru_durumu)}
                          </td>
                          <td className="px-6 py-6 whitespace-nowrap text-sm font-medium">
                            <div className="flex space-x-3">
                              <button
                                onClick={() => updateApplicationStatus(app.id, 'onayli')}
                                className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-green-600 hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 transition-all duration-200 shadow-sm"
                              >
                                <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                                </svg>
                                Onayla
                              </button>
                              <button
                                onClick={() => updateApplicationStatus(app.id, 'reddedildi')}
                                className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 transition-all duration-200 shadow-sm"
                              >
                                <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                                </svg>
                                Reddet
                              </button>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
} 